import React, { useEffect, useState } from "react";
import moment from "moment";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";
import { DatePicker } from "@material-ui/pickers";

import CommonContants from "../../constants/CommonConstants";

export default function Date(props) {
  const [browserLang, setBrowserLang] = useState("en");

  const handleDateChange = (field, date) => {
    props.handleChange(
      field,
      moment(date).format(CommonContants.FIELD_DATE_FORMAT)
    );
  };

  useEffect(() => {
    const lang = navigator.language || navigator.userLanguale;
    if (lang.toLowerCase().startsWith("ja")) {
      setBrowserLang("ja-JP"); // For Japanese
    } else {
      setBrowserLang("en-US"); // For English fallback
    }
  }, []);

  return (
    <Tooltip arrow title={props.message}>
      <Grid item={true} xs={12}>
        <div>
          <InputLabel
            className="field-label field-datePicker"
            required={props.isRequired}
          >
            {props.title}
          </InputLabel>

          {browserLang === "ja-JP" ? (
            <DatePicker
              InputProps={{ disableUnderline: true }}
              fullWidth={true}
              placeholder="YYYY-MM-DD"
              value={props.value}
              onChange={(date) => handleDateChange(props.field, date)}
              format="YYYY-MM-DD"
            ></DatePicker>
          ) : (
            <DatePicker
              InputProps={{ disableUnderline: true }}
              fullWidth={true}
              placeholder="MM/DD/YYYY"
              value={props.value}
              onChange={(date) => handleDateChange(props.field, date)}
              format={CommonContants.FIELD_DATE_FORMAT}
            ></DatePicker>
          )}
        </div>
      </Grid>
    </Tooltip>
  );
}
